import { render, staticRenderFns } from "./MangeHeader.vue?vue&type=template&id=2f82cbd4&scoped=true&"
import script from "./MangeHeader.vue?vue&type=script&lang=js&"
export * from "./MangeHeader.vue?vue&type=script&lang=js&"
import style0 from "./MangeHeader.vue?vue&type=style&index=0&id=2f82cbd4&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f82cbd4",
  null
  
)

export default component.exports